<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_DEMAND_YEAR_PRODUCTS_PROJECT'
        )
      }"
    >
      <textarea
        v-on:keyup="
          $parent.$parent.removeError(
            'PROJECTS',
            'LOGIC',
            'UF_DEMAND_YEAR_PRODUCTS_PROJECT'
          )
        "
        class="i-main-style t-dop-style i-wid-50"
        style="height:72px;"
        v-model="$parent.project.UF_DEMAND_YEAR_PRODUCTS_PROJECT"
        :disabled="$parent.$parent.projectDisabled"
        placeholder=""
      ></textarea>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_DEMAND_YEAR_PRODUCTS_PROJECT"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Uf_demand_year_products_project"
};
</script>

<style scoped></style>
